import { BadgeLegacy } from '@accure/ui';
import { ChevronRight } from 'lucide-react';
import { useBoolean } from 'usehooks-ts';

import { cls } from '@/utils/cls';

export type BadgeListCollapsedProps = {
  items: string[] | { key: string; value: React.ReactNode }[];
  defaultVisible?: number;
};

export function BadgeListCollapsed({
  items,
  defaultVisible = 3,
}: BadgeListCollapsedProps) {
  const showAllSites = useBoolean();
  const visibleItems = showAllSites.value
    ? items
    : items.slice(0, defaultVisible);
  return (
    <div className="space-y-2">
      <div className="flex flex-wrap gap-2">
        {visibleItems.map((item) => (
          <BadgeLegacy key={typeof item === 'object' ? item.key : item}>
            {typeof item === 'object' ? item.value : item}
          </BadgeLegacy>
        ))}
      </div>
      {items.length > defaultVisible && (
        <button
          onClick={() => showAllSites.toggle()}
          className="mt-1 flex items-center text-xs text-gray-500 hover:text-gray-700"
        >
          {showAllSites.value
            ? 'Show less'
            : `Show ${items.length - defaultVisible} more`}
          <ChevronRight
            className={cls('ml-1 h-3 w-3 transition-transform', {
              'rotate-90': showAllSites.value,
            })}
          />
        </button>
      )}
    </div>
  );
}
